export default {"src":"/_next/static/media/Australia.095f9b27.svg","height":3566,"width":3770,"blurWidth":0,"blurHeight":0};